import { api } from "@/lib/api";

const loadCheckoutJs = (jsHost, mid) =>
  new Promise((resolve, reject) => {
    const ready = () => {
      const cjs = window.Paytm?.CheckoutJS;
      if (!cjs) return reject(new Error("The payment window could not load. Please retry."));
      // init/invoke only exist once the bundle's onLoad callback has fired.
      if (typeof cjs.onLoad === "function") return cjs.onLoad(() => resolve(true));
      resolve(true);
    };
    const id = `paytm-js-${mid}`;
    if (document.getElementById(id)) return ready();
    const s = document.createElement("script");
    s.id = id;
    s.src = `${jsHost}/merchantpgpui/checkoutjs/merchants/${mid}.js`;
    s.crossOrigin = "anonymous";
    s.onload = ready;
    s.onerror = () => reject(new Error("The payment window could not load. Please retry."));
    document.body.appendChild(s);
  });

/**
 * Creates the order server-side, opens the gateway window and resolves with the
 * order id as soon as the customer finishes or closes it. Activation is never
 * decided here — the caller verifies server-side.
 */
export async function startPayment(payload) {
  const { data } = await api.post("/billing/paytm/start", payload);
  await loadCheckoutJs(data.js_host, data.mid);
  return new Promise((resolve, reject) => {
    const config = {
      root: "",
      flow: "DEFAULT",
      data: {
        orderId: data.order_id,
        token: data.txn_token,
        tokenType: "TXN_TOKEN",
        amount: data.amount,
      },
      merchant: { mid: data.mid, name: "Propojo", redirect: false },
      handler: {
        notifyMerchant: (event) => {
          if (event === "APP_CLOSED") {
            window.Paytm?.CheckoutJS?.close?.();
            resolve({ order_id: data.order_id, closed: true });
          }
        },
        transactionStatus: () => {
          window.Paytm?.CheckoutJS?.close?.();
          resolve({ order_id: data.order_id, closed: false });
        },
      },
    };
    window.Paytm.CheckoutJS.init(config)
      .then(() => window.Paytm.CheckoutJS.invoke())
      .catch(reject);
  });
}
